import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import FeedSection from "./components/FeedSection";
import TimelineSection from "./components/TimelineSection";
import RankSection from "./components/RankSection";
import DenySection from "./components/DenySection";
import AboutSection from "./components/AboutSection";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <FeedSection />
        <TimelineSection />
        <RankSection />
        <DenySection />
        <AboutSection />
        <FaqSection />
        <SubscribeSection />
      </main>
      <SiteFooter />
    </div>
  );
}